module.exports = __webpack_public_path__ + "kz.svg?0855baa1155ef2663125457d2f27fb81";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/kz.svg
// module id = 1459
// module chunks = 0